import { Components, Theme } from "@mui/material";

export const MuiAccordion: Components<Theme>["MuiAccordion"] = {
  styleOverrides: {
    root: () => {
      return {
        background: "none",
        border: "none",
        borderTop: "none",
        boxShadow: "none",
        "&.MuiAccordion-root::before": {
          background: "#FFF",
        },
      };
    },
  },
};
